import React from 'react';

interface PlusIconProps {
  backgroundColor?: string;
  size?: number;
  opacity?: number;
}

const PlusIcon: React.FC<PlusIconProps> = ({
  backgroundColor = '#000',
  size = 24,
  opacity = 1,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ opacity }}
  >
    <circle cx="12" cy="12" r="12" fill={backgroundColor} />
    <path
      d="M12 7V17M7 12H17"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default PlusIcon;
